module.exports = __webpack_public_path__ + "static/osickova-0a7cc90213f43f873bfefea6f959fe83.jpg";